import { getQueryString } from "utils/getQueryString";
import axios from "../axios";

const get = (queryParams) =>
  axios.get(`/transactions?${getQueryString(queryParams)}`);

const getTransactionUnderReview = (id, queryParams) =>
  axios.get(`/transactions/${id}/review?${getQueryString(queryParams)}`);

const getTransactionForChangesSignature = (id, queryParams) =>
  axios.get(
    `/transactions/${id}/changes-signature?${getQueryString(queryParams)}`
  );

const getTransactionsToReview = (queryParams) =>
  axios.get(`/transactions/review?${getQueryString(queryParams)}`);

const getTransactionsForCorrections = (queryParams) =>
  axios.get(`/transactions/corrections?${getQueryString(queryParams)}`);

const getTransactionsForSignature = (queryParams) =>
  axios.get(`/transactions/signature?${getQueryString(queryParams)}`);

const list = (queryParams) =>
  axios.get(`/transactions/getList?${getQueryString(queryParams)}`);

const updatedirectorsWhoHaveApproved = (id) =>
  axios.put(`/transactions/${id}/directors-who-have-reviewed`);

const updateTransaction = (id, data, queryParams) =>
  axios.put(`/transactions/${id}?${getQueryString(queryParams)}`, data);

const transactionDataService = {
  get,
  list,
  getTransactionsToReview,
  getTransactionsForSignature,
  getTransactionsForCorrections,
  getTransactionUnderReview,
  getTransactionForChangesSignature,
  updatedirectorsWhoHaveApproved,
  updateTransaction,
};

export default transactionDataService;
